import React, { useEffect, useState, useCallback, useMemo } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch, useAppSelector } from "@app-redux/store";
import { opportunitySelector, isAdminUser } from "@app-redux/selectors";
import { getOpportunities } from "@app-redux/thunk/opportunityThunk";
import { Loader } from "@components/Loader";
import { getColumnsForCategory } from "./columnConfig";
import { OpportunityTable } from "./OpportunityTable";
import styles from "./styles.module.css";

export const Opportunities = () => {
  const dispatch = useAppDispatch();
  const { opportunities, categories, selectedCategoryId, isLoading, error } =
    useAppSelector(opportunitySelector);
  const isAdmin = !!useAppSelector(isAdminUser);
  const [isAddingRow, setIsAddingRow] = useState(false);

  const selectedCategoryName = useMemo(() => {
    if (!selectedCategoryId) return "";
    const cat = categories.find((c) => c.id === selectedCategoryId);
    return cat?.name ?? "";
  }, [categories, selectedCategoryId]);

  const columns = useMemo(
    () => getColumnsForCategory(selectedCategoryName),
    [selectedCategoryName]
  );

  useEffect(() => {
    if (selectedCategoryId) {
      dispatch(getOpportunities(selectedCategoryId));
      setIsAddingRow(false);
    }
  }, [dispatch, selectedCategoryId]);

  const handleAddNew = useCallback(() => {
    setIsAddingRow(true);
  }, []);

  const handleCancelAdd = useCallback(() => {
    setIsAddingRow(false);
  }, []);

  return (
    <div className={styles.container}>
      {isAdmin && selectedCategoryId ? (
        <div className={styles.toolbar}>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleAddNew}
          >
            Add New
          </Button>
        </div>
      ) : (
        <div className={styles.spacer} />
      )}
      <div className={styles.tableWrapper}>
        <Loader className="profileList" show={isLoading} skipWait />
        {error && <p className={styles.errorMessage}>{error}</p>}
        {!isLoading &&
          selectedCategoryId &&
          opportunities.length === 0 &&
          !isAddingRow &&
          !error && (
            <p className={styles.emptyMessage}>
              No opportunities in this category yet
            </p>
          )}
        {(opportunities.length > 0 || isAddingRow) && selectedCategoryId && (
          <OpportunityTable
            opportunities={opportunities}
            isAdmin={isAdmin}
            isAddingRow={isAddingRow}
            onCancelAdd={handleCancelAdd}
            selectedCategoryId={selectedCategoryId}
            columns={columns}
          />
        )}
      </div>
    </div>
  );
};
